var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStandardSortDesc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.66675V10.6667H15.3333L12.6667 14.0001L10 10.6667H12V2.66675H13.3333ZM8 12.0001V13.3334H2V12.0001H8ZM9.33333 7.33342V8.66675H2V7.33342H9.33333ZM9.33333 2.66675V4.00008H2V2.66675H9.33333Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStandardSortDesc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/standard-sort-desc.d4dd8b5f.svg";
export { ForwardRef as ReactComponent };